<template>
  <Modal 
    :id="'cpm-add-invoice-modal'" 
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('new_release')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'release_artist'"
          
          v-bind="textFieldConfig"
          :value="release_artist"
          required
          :placeholder="$t('artist_name')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          class="m1"
          :id="'release_title'"
          
          v-bind="textFieldConfig"
          :value="release_title"
          required
          :placeholder="$t('Title')"
          @valuechanged="onTextFieldValueChange"
           @validated="onValidation"
        ></TextField>
      
        <TextField
          type="date"
          id="release_date"
          class="m1"
          :placeholder="$t('Release Date')"
          :value="release_date"
          :showImmediate="true"
          autocomplete="off"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          :id="'identifier'"
          :value="identifier"
          
           v-bind="textFieldConfig"
          class="m1"
          :placeholder="$t('release_code')"
          :showValidationIcons="false"
          @valuechanged="onTextFieldValueChange"
           @validated="onValidation"
           
        ></TextField>
        <Dropdown
          :options="releaseStatusesTV || []"
          :id="'label_status_id'"
          class="m2"
          :selected="releaseStatusesTV.find(e=> e.value == label_status_id)"
          :placeholder="$t('releases_status')"
          @selectedChange="e => onDropdownChange('label_status_id', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <Dropdown
          :options="labelsTV || []"
          :id="'label_id'"
          class="m2"
          :selected="labelsTV.find(e=> e.value == label_id)"
           :placeholder="$t('labels')"
          @selectedChange="e => onDropdownChange('label_id', e)"
          box
          :showValidationIcons="true"
          :immediateValidation="true"
           required
          @validated="e => onValidation('label_id', e)"
          :listHeight="250"
        ></Dropdown>
     
      </div>
    </template>
    <template slot="options">
     
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >{{$t('cancel')}}</button>
      <button
        class="dt-button s6 v1"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewReleases"
      >
     {{$t('add_new_release')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';
import { releaseService } from '../../services/releases/releases.services';

export default {
  components: {
    Modal,
  },
  props: {
    statuses: {
      type: Array
    },
    // labels: {
    //   type: Array
    // }
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      release_artist:'',
      release_title:'',
      release_date:'',
      identifier:'',
      label_status_id:null,
      label_id:null,
      loading: false,

      labels:[],
      validationResult: {},
    };
  },
  mounted:async function() {
    const res = await releaseService.createReleaseInitModal();
    console.log("WERE",res);
    this.labels =res.data.labels;
  },
  computed: {
    selectedGroups: function() {
      return this.contactType === "person"
        ? this.person.groups
        : this.company.groups;
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    labelsTV: function(){
      return this.labels.map(e=> {
        return {
          text: e.label_name,
          value:e.label_id
        };
      }).filter(e => e.text != "");
    },
    releaseStatusesTV: function() {
      return this.statuses.map( e=> {
        return {                                      
          text: e.label_status_name,
          value:e.label_status_id
        };
      });
    },
    // releaseEntry:function(){
    //    return{
    //      release_artist:this.release_artist,
    //      release_title:this.release_title,
    //      label_id:this.label_id,
    //      identifier:this.identifier,
    //      release_date:this.release_date,
    //      label_status_id:this.label_status_id
    //    }
    // }

  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onDateChange: function(name, value) {
      console.log(name, value);
      this.releaseDate = value;
      
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this[key]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addNewReleases: async function(e) {

      this.$emit('addRelease', {
         release_artist:this.release_artist,
         release_title:this.release_title,
         label_id:this.label_id,
         identifier:this.identifier,
         release_date:this.release_date,
         label_status_id:this.label_status_id
       });
    },
    onDropdownChange: function(name, value) {
    
      this[name]=value.value
      // if(name=='status'){
      //   this.selectedStatus=value.value;
      //     console.log("EEEEEEEEEE",name, value);
      // }
      // else if(name=='label'){
      //   this.selectedLabels=value.value;
      //    console.log("EEEEEEEEEE",name, value,this.selectedStatus,this.selectedLabels);
      // }
      // this[name] = value;
      
    },

    //MARK: Methods
  }
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group = []
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  group = []
} = {}) => {
  return {
    companyName,
    city,
    country,
    group
  };
};
</script>

<style lang="scss">
.cpm-add-invoice-modal {
}
</style>